module.exports = __webpack_public_path__ + "img/block_4.38935d97.webp";